import type cytoscape from 'cytoscape'

const HIGHLIGHTED_CLASS = 'highlighted'

/**
 * Sets up edge highlighting on node hover.
 * When a node is hovered, all connected edges (both incoming and outgoing)
 * are highlighted to visualize the connections.
 */
export function setupEdgeHighlight(cy: cytoscape.Core): void {
  cy.on('mouseover', 'node', event => {
    const node = event.target as cytoscape.NodeSingular
    // Highlight all edges connected to this node
    node.connectedEdges().addClass(HIGHLIGHTED_CLASS)
  })

  cy.on('mouseout', 'node', event => {
    const node = event.target as cytoscape.NodeSingular
    // Remove highlight from all edges connected to this node
    node.connectedEdges().removeClass(HIGHLIGHTED_CLASS)
  })
}
